/* unplugin-vue-components disabled */import { render } from "./ai-tabs.vue?vue&type=template&id=a4b6351e&scoped=true"
import script from "./ai-tabs.vue?vue&type=script&lang=js"
export * from "./ai-tabs.vue?vue&type=script&lang=js"

import "./ai-tabs.vue?vue&type=style&index=0&id=a4b6351e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4b6351e"],['__file',"src/components/ai-chat/ai-tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a4b6351e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a4b6351e', __exports__)) {
    api.reload('a4b6351e', __exports__)
  }
  
  module.hot.accept("./ai-tabs.vue?vue&type=template&id=a4b6351e&scoped=true", () => {
    api.rerender('a4b6351e', render)
  })

}


export default __exports__